import { UnicodeEntity } from '@mews/enums';
import { Stack, Tag, Typography } from '@optimus-web/core';
import { Currency, DataTestId } from '../types';

interface SelectionCardGroupOptions {
    currencies: Currency[];
    propertyCurrencyCode?: string;
    propertyCurrencyLabelText?: string;
}

export const getSelectionCardGroupOptions = ({
    currencies,
    propertyCurrencyCode,
    propertyCurrencyLabelText,
}: SelectionCardGroupOptions) =>
    currencies.map((currency) => ({
        label: (
            <Stack spacing="200">
                <Typography textStyle="bodyMediumStrong" as="div">
                    {currency.symbol}
                    {UnicodeEntity.NoBreakSpace}
                    {currency.code}
                </Typography>
                {currency.code === propertyCurrencyCode && propertyCurrencyLabelText !== undefined && (
                    <Tag variant="basicBold">{propertyCurrencyLabelText}</Tag>
                )}
            </Stack>
        ),
        description: (
            <Typography textStyle="bodyMedium" variant="secondary" as="div">
                {currency.description}
            </Typography>
        ),
        name: currency.code,
        value: currency.code,
        dataTestId: DataTestId.CurrencySelectDialogSelectionCard,
    }));
